module.exports = __webpack_public_path__ + "img/luyin.ea715aa2.png";